import React, {Component} from 'react';
import {withSession} from "../Session/context";
import {withFirebase} from "../Firebase";
import Option from "../Option";
import Header from "../Header";
import {Link} from "react-router-dom";
import languages from "../../utils/languages";

class PageProjectLanguage extends Component {
    componentDidMount() {
        this.setState({ languages: Object.entries(languages) })
    }

    render() {
        const listItems = this.state && this.state.languages.map(lang => {
            return (
                <Link key={lang[0]} to={`/project/${this.props.match.params.project}/${lang[0]}`}>
                    <Option title={lang[1]} />
                </Link>
            )
        });

        return (
            <div>
                <Header title={"Choose a language"} subtitle={"Translate"} />
                {listItems}
            </div>
        );
    }
}

export default withSession(withFirebase(PageProjectLanguage));